<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    uploaderOptions: {
      type: Object,
      default: () => ({}),
    },
    additionalParams: {
      type: Object,
      default: () => ({}),
    },
    uploader: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    deleteMethod: {
      type: Function,
      default: () => null,
    },
    deleteDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      uploadDialog: false,
      deleteIndex: null,
      galleryImages: this.images.slice(),
    }
  },

  watch: {
    images(val) {
      this.galleryImages = val.slice()
    },
  },

  methods: {
    openDeleteDialog(index) {
      // this.deleteDialog = true
      this.$emit('update:deleteDialog', true)
      this.deleteIndex = index
    },
    closeDialog() {
      // this.deleteDialog = false
      this.$emit('update:deleteDialog', false)
      this.deleteIndex = null
    },
    addImage(res) {
      this.galleryImages.push(res)
    },
    closeUploader() {
      this.uploadDialog = false
      this.$refs.uploader.clearFiles()
    },
  },
}
</script>

<template>
  <VContainer
    :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-3'"
    grid-list-md
    fluid
  >
    <VLayout row wrap>
      <!-- Image List -->
      <VFlex
        v-for="(image, index) in galleryImages"
        :key="image.src"
        xs3
        sm2
        d-flex
      >
        <div>
          <VCard class="d-flex" flat tile>
            <VImg
              :src="image.src"
              :lazy-src="image.src"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <VLayout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <VProgressCircular color="grey lighten-5" indeterminate />
              </VLayout>
            </VImg>
          </VCard>
          <div>
            <VBtn block flat @click="openDeleteDialog(index)">
              <v-icon>delete</v-icon>
            </VBtn>
          </div>
        </div>
      </VFlex>
      <!-- End of Image List -->

      <!-- Image Uploader -->
      <VFlex v-if="uploader" xs3 sm2 d-flex @click="uploadModal = true">
        <VDialog v-model="uploadDialog" width="620" persistent>
          <!-- Image Uploader Placeholder -->
          <VCard slot="activator" class="d-flex upload" flat tile>
            <VImg class="grey lighten-4" aspect-ratio="1">
              <VLayout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0
              >
                <VIcon :large="$vuetify.breakpoint.smAndDown">
                  add
                </VIcon>
              </VLayout>
            </VImg>
          </VCard>
          <!-- End of Image Uploader Placeholder -->

          <!-- Image Uploader Container -->
          <VCard>
            <VCardTitle :class="`headline ${color}--text`">
              Image upload
            </VCardTitle>

            <VCardText>
              <BaseImgUpload
                ref="uploader"
                :options="uploaderOptions"
                :additional-params="additionalParams"
                @upload-success="addImage"
              />
            </VCardText>

            <VCardActions class="grey lighten-3">
              <VSpacer />
              <VBtn dark depressed :color="color" @click="closeUploader">
                Close
              </VBtn>
            </VCardActions>
          </VCard>
          <!-- End of Image Uploader Container -->
        </VDialog>
      </VFlex>
      <!-- End of Image Uploader -->
    </VLayout>

    <VDialog v-model="deleteDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Delete image</VCardTitle>

        <VCardText>Are you sure want to delete this image?</VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="closeDialog">
            Cancel
          </VBtn>

          <VBtn :color="color" flat @click="$emit('delete-img', deleteIndex)">
            Delete
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </VContainer>
</template>

<style>
.d-flex .upload {
  cursor: pointer;
  border-color: #bdbdbd !important;
  border-style: dashed;
  border-width: 2px;
}
</style>
